import React from 'react'
import { css } from '@emotion/core'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'

type OtpMailHelpPopupProps = {
  isOpen: boolean
  hotelEmail?: string
  onSendToHotel: () => void
  onCancel: () => void
}

export const OtpMailHelpPopup: React.FC<OtpMailHelpPopupProps> = ({ isOpen, hotelEmail, onSendToHotel, onCancel }) => {
  if (!isOpen) {
    return null
  }

  return (
    <div css={overlayStyle} onClick={onCancel}>
      <div css={popupStyle} onClick={event => event.stopPropagation()}>
        <p css={titleStyle}>メールを受け取れない場合</p>
        <p css={descriptionStyle}>メールが受信できない場合、施設の代表メールアドレスに確認コードを再送します。</p>

        <div css={emailBoxStyle}>
          <p css={emailLabelStyle}>施設代表メールアドレス</p>
          <p css={emailValueStyle}>{hotelEmail || '-'}</p>
        </div>

        <Button
          buttonType={ButtonType.Primary}
          width={275}
          height={38}
          marginTop={22}
          marginLeft={'auto'}
          marginRight={'auto'}
          onClick={onSendToHotel}
        >
          施設代表メールに送る
        </Button>

        <Button
          buttonType={ButtonType.Secondary}
          width={275}
          height={38}
          marginTop={14}
          marginLeft={'auto'}
          marginRight={'auto'}
          onClick={onCancel}
        >
          キャンセル
        </Button>
      </div>
    </div>
  )
}

const overlayStyle = css({
  position: 'fixed',
  inset: 0,
  zIndex: 1200,
  background: 'rgba(0, 0, 0, 0.52)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px',
})

const popupStyle = css({
  width: 400,
  maxWidth: '92vw',
  background: '#FFFFFF',
  borderRadius: 5,
  padding: '40px 28px 34px',
})

const baseTextStyle = css({
  fontSize: 12,
  color: '#272727',
  lineHeight: 1.5,
})

const titleStyle = css(baseTextStyle, {
  fontSize: 18,
  fontWeight: 700,
  margin: 0,
})

const descriptionStyle = css(baseTextStyle, {
  margin: '18px 0 0',
  color: '#676767',
})

const emailBoxStyle = css({
  marginTop: 16,
  borderRadius: 5,
  background: '#F4F7FC',
  padding: '14px 18px',
})

const emailLabelStyle = css(baseTextStyle, {
  margin: 0,
})

const emailValueStyle = css(baseTextStyle, {
  margin: '4px 0 0',
  fontWeight: 700,
})
